import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './VideoTranscript.module.css';

const TranscriptCard = ({
  index,
  date,
  userOne,
  userTwo,
  onButtonClick,
  onDeleteTranscript,
}) => {
  const { t } = useTranslation();
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  const formattedTime = new Date(date).toLocaleTimeString('en-US', {
    minute: 'numeric',
    hour: 'numeric',
  });

  return (
    <div className={classes.transcriptCard}>
      <div className={classes.transcriptCard_title}>
        <h3>{t('screens.video.transcript.cardIndex', { index: index + 1 })}</h3>
        <p>{formattedDate + ' ' + formattedTime}</p>
      </div>
      <h2 className={classes.transcriptCard_content}>
        {t('screens.video.transcript.cardBetween', { userOne, userTwo })}
      </h2>
      <div className={classes.transcriptCard_btns}>
        <button
          className={classes.transcriptCard_details}
          onClick={onButtonClick}
        >
          {t('screens.video.transcript.cardDetails')}
        </button>
        <button className='table__button_delete' onClick={onDeleteTranscript}>
          <svg className='table__button_delete_icon'>
            <use xlinkHref={`/assets/sprite.svg#icon-trash`} />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TranscriptCard;
